<template>
	<div class="products-placeholder">
		<img
			:src="placeholderIcon"
			alt="placeholder"
			class="products-placeholder__image"
		/>
		<div class="products-placeholder__title bold">
			{{ placeholderTitle }}
		</div>
		<div class="products-placeholder__description">
			Check later!
		</div>
	</div>
</template>

<script>
import { PRODUCTS_FILTER_Values } from '@/constants'

// Icons
import PlaceholderIcon from '@/assets/images/food_placeholder_nodata.svg'

export default {
	name: 'ProductsPlaceholder',

	data: () => ({
		filter: PRODUCTS_FILTER_Values.all
	}),

	computed: {
		placeholderTitle() {
			if (this.filter === PRODUCTS_FILTER_Values.all) return 'NO PRODUCTS'
			if (this.filter === PRODUCTS_FILTER_Values.new) return 'NO NEW'

			return 'NO STAFF FAVORITES'
		},

		placeholderIcon() {
			return PlaceholderIcon
		}
	},

	watch: {
		$route(nv, ov) {
			// eslint-disable-next-line
			if (!nv.query.filter && (nv.query.filter === ov.query.filter || this.filter === nv.query.filter)) return

			this.filter = nv.query.filter
		}
	},

	created() {
		this.checkFilter()
	},

	methods: {
		checkFilter() {
			if (this.$route.query?.filter === PRODUCTS_FILTER_Values.favorite) {
				this.filter = PRODUCTS_FILTER_Values.favorite
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.products-placeholder {
	width: fit-content;
	margin: 40px auto 30px auto;

	&__image {
		display: block;
		margin: 0 auto 24px auto;
		width: 200px;
		height: 200px;

		@media (max-width: 767px) {
			width: 150px;
			height: 150px;
		}
	}

	&__description,
	&__title {
		text-align: center;
	}

	&__title {
		padding-bottom: 8px;
		margin-bottom: 4px;
		min-width: 284px;
		font-size: 24px;
		line-height: 30px;
		letter-spacing: 1.06px;
		color: $semi-dark-blue;
		border-bottom: 2px solid $blue-faceless-void;

		@media (max-width: 767px) {
			min-width: 236px;
			font-size: 20px;
			letter-spacing: 0.88px;
		}
	}

	&__description {
		font-size: 16px;
		line-height: 22px;
		color: $grey;
	}
}
</style>
